import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DropFitnessSDKService {

  config: any;
  facilityId: number;
  corporateUrl: string = '';
  facilityUrl: string = '';
  apiVersion: string = 'api/v1/';

  private _requestingUrl: Promise<unknown> | null = null;

  /** Facility id for which `facilityUrl` was last set (static map or connection API). */
  private _resolvedFacilityId: number | null = null;

  constructor(private http: HttpClient) {
    this.config = environment.dropfitnessConfig;
    this.facilityId = environment.defaultFacilityId;
  }

  /**
     * Registers the user with given details
     */
  registerUser = (email: any, password: any) => {
    return new Promise((resolve, reject) => {
      // firebase.auth().createUserWithEmailAndPassword(email, password).then((user: any) => {
      //     var user: any = firebase.auth().currentUser;
      //     resolve(user);
      // }, (error: any) => {
      //     reject(this._handleError(error));
      // });
    });
  }

  initializeConfig = (facilityId: number) => {
    if (facilityId !== this.facilityId) {
      this.facilityUrl = '';
      this._resolvedFacilityId = null;
    }
    this.facilityId = facilityId;
    this.ensureUrls();
  }

  /**
   * When `environment.preferStaticFacilityUrl` is set (local config), use the facility base URL from
   * `dropfitnessConfig.facilityUrl[facilityId]` and skip the corporate Facility/connection lookup.
   */
  private resolveStaticFacilityBase(): string | null {
    if (!(environment as { preferStaticFacilityUrl?: boolean }).preferStaticFacilityUrl) {
      return null;
    }
    const map = this.config.facilityUrl as Record<string, string> | undefined;
    if (!map) {
      return null;
    }
    const raw = map[String(this.facilityId)];
    if (!raw) {
      // fall back to connection API if this facility is not mapped
      return null;
    }
    return raw.endsWith('/') ? raw : `${raw}/`;
  }

  ensureUrls = () => {
    if (this._requestingUrl) {
      return this._requestingUrl;
    }

    this.corporateUrl = this.config.baseUrl;

    const staticFacilityBase = this.resolveStaticFacilityBase();
    if (staticFacilityBase) {
      this.facilityUrl = staticFacilityBase;
      this._resolvedFacilityId = this.facilityId;
      this._requestingUrl = Promise.resolve(true).finally(() => {
        this._requestingUrl = null;
      });
      return this._requestingUrl;
    }

    if (this.facilityUrl && this._resolvedFacilityId === this.facilityId) {
      return Promise.resolve(true);
    }

    this._requestingUrl = new Promise((resolve, reject) => {
      this.http
        .get<string>(`${this.corporateUrl}${this.apiVersion}Facility/connection/${this.facilityId}`)
        .subscribe({
          next: (connection: string) => {
            if (connection) {
              this.facilityUrl = connection.endsWith('/') ? connection : `${connection}/`;
              this._resolvedFacilityId = this.facilityId;
              resolve(true);
            } else {
              reject(new Error('Error loading connection string'));
            }
            this._requestingUrl = null;
          },
          error: (err: unknown) => {
            this._requestingUrl = null;
            reject(err);
          }
        });
    });
    return this._requestingUrl;
  }

  versionedCorpUrl = (version: string = '') => {
    return this.corporateUrl + (version || this.apiVersion);
  }

  versionedFacilityUrl = (version: string = '') => {
    return this.facilityUrl + (version || this.apiVersion);
  }

  /**
   * Login user with given details
   */
  loginUser = (email: any, password: any, facilityId: number) => {
    this.initializeConfig(facilityId);

    return new Promise((resolve, reject) => {
      this.http.post<any>(`${this.config.baseUrl}${this.apiVersion}Auth/Signin`,
        {
          facilityId,
          role: 8, // PT role for now, will need to extend to other roles
          username: email,
          password
        })
        .subscribe((user: any) => {
          // login successful if there's a jwt token in the response
          if (user && user.Token) {
            resolve(user);
          } else {
            reject(this._handleError(user));
          }
          return user;
        },
        (error: any) => {
          console.log("Auth/Login error", error);
          reject(this._handleError(error));
          return error;
        });

      // firebase.auth().signInWithEmailAndPassword(email, password).then((user: any) => {
      //     // eslint-disable-next-line no-redeclare
      //     var user: any = firebase.auth().currentUser;
      //     resolve(user);
      // }, (error: any) => {
      //     reject(this._handleError(error));
      // });
    });
  }

  resetPassword = (email: any) => {
    return new Promise((resolve, reject) => {
      this.http.post<any>(`${this.config.baseUrl}${this.apiVersion}Auth/ResetPassword`,
        {
          role: 8, // PT role for now, will need to extend to other roles
          email: email
        })
        .subscribe((response: any) => {
          // reset successful
          resolve(response);
          return response;
        },
          (error: any) => {
            console.log("Auth/ResetPassword error", error);
            reject(false);
            return false;
          });
    });
  }

  changePassword = (userId: number, oldPassword: string, password: string, confirmPassword: string) => {
    var inputPayload = {
      userId: userId,
      role: 8, // PT role for now, will need to extend to other roles
      oldPassword: oldPassword,
      password: password,
      confirmPassword: confirmPassword
    };
    return new Promise((resolve, reject) => {
      this.http.post<any>(`${this.config.baseUrl}${this.apiVersion}Auth/Corporate/ChangePassword`, inputPayload)
        .subscribe((response: any) => {
          // reset successful
          resolve(response);
          return response;
        },
          (error: any) => {
            console.log("Auth/Corporate/ChangePassword error", error);
            var response = { success: false, message: error };
            reject(response);
            return error;
          });
    });
  }

  /**
   * Logout the user
   */
  logout = () => {
    return new Promise((resolve, reject) => {
      // firebase.auth().signOut().then(() => {
      //     resolve(true);
      // }).catch((error: any) => {
      //     reject(this._handleError(error));
      // });
    });
  }

  /**
   * forget Password user with given details
   */
  forgetPassword = (email: any) => {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line: max-line-length
      // firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + '//' + window.location.host + '/login' }).then(() => {
      //     resolve(true);
      // }).catch((error: any) => {
      //     reject(this._handleError(error));
      // });
    });
  }

  setLoggeedInUser = (user: any) => {
    sessionStorage.setItem('authUser', JSON.stringify(user));
  }

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    if (!sessionStorage.getItem('authUser')) {
      return null;
    }
    return JSON.parse(sessionStorage.getItem('authUser')!);
  }

  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error: any) {
    // tslint:disable-next-line: prefer-const
    var errorMessage = error.message;
    return errorMessage;
  }
}
